import { render, staticRenderFns } from "./TemplateWithHeader.vue?vue&type=template&id=0f4cb31a&scoped=true"
import script from "./TemplateWithHeader.vue?vue&type=script&lang=js"
export * from "./TemplateWithHeader.vue?vue&type=script&lang=js"
import style0 from "./TemplateWithHeader.vue?vue&type=style&index=0&id=0f4cb31a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4cb31a",
  null
  
)

export default component.exports